// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PeopleFliterSvg from '@rsuite/icon-font/lib/people/PeopleFliter';
var PeopleFliter = createSvgIcon({
  as: PeopleFliterSvg,
  ariaLabel: 'people fliter',
  category: 'people',
  displayName: 'PeopleFliter'
});
export default PeopleFliter;